import { Sort } from '@/engage/types/sort'

export default Object.freeze({
  DUE_DATE: Sort.DUE_DATE,
  LAST_INTERACTION_DATE_IN: Sort.LAST_INTERACTION_DATE_IN,
  WAKE_UPDATE: Sort.WAKE_UPDATE,
  CREATION_DATE: Sort.CREATION_DATE,
  AGENT_ASSIGN_DATE: Sort.AGENT_ASSIGN_DATE,
})
